// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606290756/js/" + chunkId + "." + {"44":"354236ab","225":"8b6fb8dd","481":"25c3f8df","486":"3c4e4a7e","770":"c63e632b"}[chunkId] + ".0.7974103485629126.chunk.js";
};